import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'

var mixin = {
  components: {
    'error-display-component': ErrorDisplayComponent
  }
}
export default mixin
